import { Chip } from '@mui/material';
import { Paperclip } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import apiReq from 'core/api';
import styles from './AttachmentChipsList.module.scss';

interface ContextFile {
  id: string;
  name: string;
  url?: string;
  content_length?: number;
}

interface AttachmentChipsListProps {
  documentIds: string[];
  projectId: string;
  chatId: string | null;
}

const AttachmentChipsList = ({ documentIds, projectId, chatId }: AttachmentChipsListProps) => {
  const { data: files = [] } = useQuery<ContextFile[]>({
    queryKey: ['contextDocuments', projectId, chatId],
    queryFn: async () => {
      const params = new URLSearchParams({ project_id: String(projectId) });
      if (chatId) params.set('chat_id', chatId);
      const result = await apiReq<ContextFile[]>(
        `projects/context-documents?${params.toString()}`,
        'GET'
      );
      return result || [];
    },
    enabled: !!projectId && !!chatId && documentIds.length > 0,
    staleTime: 30_000,
  });

  if (documentIds.length === 0) return null;

  const byId = new Map(files.map((f) => [f.id, f]));
  const resolved = documentIds.map((id) => byId.get(id)).filter(Boolean) as ContextFile[];

  if (resolved.length === 0) return null;

  return (
    <div className={styles.list}>
      {resolved.map((f) => (
        <Chip
          key={f.id}
          size="small"
          variant="outlined"
          icon={<Paperclip size={12} />}
          label={f.name}
          onClick={f.url ? () => window.open(f.url, '_blank', 'noopener') : undefined}
          className={styles.chip}
        />
      ))}
    </div>
  );
};

export default AttachmentChipsList;
